import React, { FC, useEffect, useState } from "react";
import MainLayout from "../../Layouts/MainLayout";
import { service } from "../../../services/AxiosServices";
import SectionHeader from "../molecules/SectionHeader";
import WindowHeightComponent from "../../Layouts/WindowHeight";
const ManageCompany: FC = () => {
  const [companies, setCompanies] = useState<any[]>([]);

  const fetchCompanies = async () => {
    try {
      const response = await service<any>("/api/tenant-list/", "post");
      setCompanies(response.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchCompanies();
  }, []);

  return (
    <MainLayout>
      <SectionHeader title="Manage companies" back={true} />
      <WindowHeightComponent className={""}>
        <div className="d-flex flex-column h-100">
          <div className="flex-grow-1">
            <div className="d-flex align-items-center p-3">
              <div className="flex-1">
                <div className="manage-container-grid mb-5">
                  {companies.map((company, index) => (
                    <div key={index} className="manage-companies mb-3">
                      <div><strong>{company?.name}</strong></div>
                      <div><strong>Details: </strong></div>
                      <div><strong>Email: </strong>{company?.email}</div>
                      <div><strong>C admin: </strong>{company?.admin_profile_details?.user?.first_name } {company?.admin_profile_details?.user?.last_name}</div>
                      <div><strong>Phone no: </strong> {company?.admin_profile_details?.phone} </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </WindowHeightComponent>
    </MainLayout>
  );
};

export default ManageCompany;
